import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { translate } from '@optimusgps/optimus-intl';
import { Button, Form, Input } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { REGEX } from '@/constants/global';
import { parsePhoneNumber } from '@/utilities/utilities';

type Props = {
	form: FormInstance;
	onSubmit: () => void;
	isLoading: boolean;
};

type FormValues = {
	email: string;
	phoneNumber: string;
};

const initialValues: FormValues = {
	email: '',
	phoneNumber: '',
};

export const SmsForm = ({ form, isLoading, onSubmit }: Props) => {
	const intl = useIntl();

	const [formHasErrors, setFormHasErrors] = useState<boolean>(false);

	const handleFormChange = (): void => {
		const hasErrors = form.getFieldsError().filter(({ errors }) => errors.length).length > 0;
		setFormHasErrors(hasErrors);
	};

	return (
		<Form
			className="sms-form"
			layout={'inline'}
			initialValues={initialValues}
			form={form}
			onFieldsChange={handleFormChange}
		>
			<Form.Item
				className="sms-form-items"
				name="email"
				label={intl.formatMessage(translate('email'))}
				rules={[
					{
						required: true,
						message: intl.formatMessage(translate('emailRequired')),
					},
					{
						pattern: REGEX.email,
						message: intl.formatMessage(translate('emailError')),
					},
				]}
			>
				<Input placeholder={intl.formatMessage(translate('email'))} />
			</Form.Item>
			<Form.Item
				className="sms-form-items"
				name="phoneNumber"
				label={intl.formatMessage(translate('phoneNumber'))}
				rules={[
					{ whitespace: true },
					() => ({
						validator(_, value) {
							const isValid = parsePhoneNumber(value);
							if (!value || isValid) {
								return Promise.resolve();
							}
							return Promise.reject(intl.formatMessage(translate('phoneValid')));
						},
					}),
				]}
			>
				<Input placeholder={intl.formatMessage(translate('phoneNumber'))} />
			</Form.Item>
			<Button
				className="btn-form"
				key="ok"
				type="primary"
				onClick={onSubmit}
				loading={isLoading}
				disabled={formHasErrors}
			>
				<FormattedMessage {...translate('searchPlaceholder')} />
			</Button>
		</Form>
	);
};
